import { AbstractControl, FormGroup } from '@angular/forms';
import { Option } from '@digilize/shared/definitions/src';
import { TranslateService } from '@ngx-translate/core';

function StringIsNumber(value: string): boolean {
  return isNaN(Number(value)) === false;
}

export function enumToArrOfObjs(e: Record<string, string | number>) {
  return Object.keys(e)
    .filter(StringIsNumber)
    .map((key) => ({ text: e[key], val: Number(key) }));
}

export function createOptions(data: Array<{ id: string; name: string }>): Option[] {
  return data
    .filter((item) => item.name != null)
    .map((item) => ({
      id: item.id,
      text: item.name,
      val: String(item.id),
    }));
}

export function transformToOption(data: { skill_id: string; skill_name: string }) {
  return {
    id: data.skill_id,
    text: data.skill_name,
    val: data.skill_id,
  };
}

export function mergeData(obj1: Record<string, unknown>, obj2: Record<string, unknown>): Record<string, unknown> {
  const merged = { ...obj1 };
  for (const key in obj2) {
    if (!Object.prototype.hasOwnProperty.call(merged, key)) {
      merged[key] = obj2[key];
    }
  }
  return merged;
}

export function removePropsFromObj(obj: Record<string, unknown>, props: string[]): void {
  props.forEach((property) => {
    if (Object.prototype.hasOwnProperty.call(obj, property)) {
      delete obj[property];
    }
  });
}

export function removeValidation(formGroup: FormGroup, controlName: string): void {
  const control: AbstractControl = formGroup.get(controlName);
  if (control) {
    control.clearValidators();
    control.updateValueAndValidity();
  }
}

export function translateCountryCodes(codes: any[], translateService: TranslateService): any[] {
  const countriesArr: any[] = [];
  for (const code of codes) {
    countriesArr.push({
      text: translateService.instant('form.countries.' + code.code.toLowerCase()),
      val: code.code,
    });
  }
  return countriesArr;
}